import { Alert, Box, IconButton, TextField, Typography, Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import React, { useContext, useState } from 'react';
import axios from 'axios';
import { useSnackBar } from '../../../contexts/snackbar';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../../configurations/global.config';

interface NotificationFooterProps {
  value: string;
  onSave?: (newFooter: string) => void;
}

const MAX_LENGTH = 500;

function NotificationFooter({ value, onSave }: NotificationFooterProps) {
  const { user, config } = useContext(AuthContext);
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [footer, setFooter] = useState(value ?? '');
  const [charCount, setCharCount] = useState(footer.length);
  const { showMessage } = useSnackBar();

  const handleEdit = () => setEditMode(true);
  const handleCancel = () => {
    setFooter(value);
    setCharCount(value.length);
    setEditMode(false);
  };
  const handleSave = async () => {
    setIsLoading(true);
    try {
      await axios.post(`${API_ENDPOINT}/api/v1/settings`, { delivery_notification_footer: footer },config);
      showMessage('Notification footer updated successfully.', 'success');
      onSave?.(footer);
    } catch (e) {
      console.error('Error validating footer length:', e);
      showMessage('Operation not allowed for the selected orders.', 'error');
    }
    setIsLoading(false);
    setEditMode(false);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.slice(0, MAX_LENGTH);
    setFooter(val);
    setCharCount(val.length);
  };

  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        This footer will be appended to all notification messages sent to customers upon delivery.
      </Alert>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ flex: 1 }}>
            <TextField
              multiline
              fullWidth
              value={footer}
              onChange={handleChange}
              inputProps={{ maxLength: MAX_LENGTH }}
              variant="outlined"
              sx={{ mt: 1 }}
              minRows={4}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
              <Typography variant="caption" color={charCount === MAX_LENGTH ? 'error' : 'textSecondary'}>
                {charCount}/{MAX_LENGTH} characters
              </Typography>
              {footer !== value &&<Box>
                <Button size="small" disabled={isLoading} onClick={handleCancel} sx={{ mr: 1 }}>Cancel</Button>
                <Button size="small" disabled={isLoading} variant="contained" onClick={handleSave}>Save</Button>
              </Box>}
            </Box>
          </Box>
      </Box>
    </Box>
  );
}

export default NotificationFooter;